import Vue from 'vue';
import { ApiService } from '@/services/api.service'
import { Log } from '@/services/log.service'

import { store } from '@/store'
import { mapState } from 'vuex';
import router from '@/router'


export const BootService = new Vue({
	store,
	router,
	computed: {
		...mapState(['settings', 'globals']),
	},

	methods: {

		/**
		 * 	Der Boot-Prozess:
		 * 	Wird in der main.js bei Initialisierung aufgerufen.
		 *
		 */
		init() {

			return new Promise((resolve, reject) => {

				// Lokale Voreinstellungen laden
				this.$store.dispatch('settings/LOAD').then( ({ data }) => {

					// ... danach API initialisieren
					ApiService.init();
					
					// ... settings.json laden
					ApiService.loadSettings().then(({ data }) => {

						this.$store.commit('settings/MODIFY', {presets:data});

						// ...navigation.json laden
						ApiService.loadNavigation().then(({ data }) => {

							this.$store.commit('navigation/SET_DATA', data);

							resolve( {data:data} );
						});

					}).catch( reject );

				}).catch( reject );
			})
		},

	}
});
